import {
  SelectPassThroughAttributes,
  SelectPassThroughOptions,
  SelectPassThroughOptionType,
} from 'primevue';
import { PassThrough } from '@primevue/core';
import { PassThroughMeridiaInput } from '../../input/types';
import { PassThroughOptionType } from '../../utils';

export enum SingleSelectType {
  SINGLE = 'single',
  SINGLE_WITH_RADIO = 'single_with_radio',
}

export type PassThroughMeridiaSingleSelect =
  PassThrough<SelectPassThroughOptions> & {
    dropdownIcon?: { class: string };
    header?: SelectPassThroughOptionType;
    filterInput?: PassThroughMeridiaInput;
    value?: PassThroughOptionType<
      SelectPassThroughAttributes,
      {
        value: any;
      }
    >;
    meridiaOption?: PassThroughOptionType<
      SelectPassThroughAttributes,
      {
        option: any;
        selected: boolean;
        index: number;
      }
    >;
  };
